import Construct from './Construct';

export default Construct;
